import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Trip_trip } from '../../../../__generated__/Trip';
import { TripCreateFormValues } from '../../../../types';
import { TripAvailableDocumentTypes } from '../__generated__/TripAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';

 interface AttachFormProps {
  availableDocumentTypes: TripAvailableDocumentTypes | undefined;
  tripData: Trip_trip | null | undefined;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  availableDocumentTypes,
  tripData,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<TripCreateFormValues>();
  return (
    <AttachFormModal
      tripData={tripData}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={isDirty}
    />
  );
};
